import { Dispatch, SetStateAction, useState } from "react";
import CostColumns from "../lib/CostColumns";
import OperationLayout from "../lib/OperationLayout";
import Input from "../lib/Input";
import VolumeDiscount from "../lib/VolumeDiscount";
import { quantityColumnWidth } from "../constants";
import useOperationContext from "../lib/useOperationContext";
import useOperationListContext from "../lib/useOperationListContext";
import OperationHeader from "../lib/OperationHeader";
import MaterialNameSelect from "../MaterialNameSelect";
import UnitCostInput from "../lib/UnitCostInput";
import { hasSomeValidationErrorsInFields } from "../lib/getValidationErrors";
import { Operation } from "../lib/types";

export default function MaterialPurchasedComponent() {
  const { operationData: data } = useOperationContext();
  const { id, validation_errors } = data;
  const expandByDefault = hasSomeValidationErrorsInFields({
    errors: validation_errors,
    expandedPanelFields: ["discount_rates", "min_blank_cost", "markup"],
  });
  const [expand, setExpand] = useState(expandByDefault);

  return (
    <OperationLayout
      id={id as string}
      left={<Left operation={data} expand={expand} setExpand={setExpand} />}
      right={<Right expand={expand} />}
    />
  );
}

function Left({
  operation,
  expand,
  setExpand,
}: {
  operation: Operation;
  expand: boolean;
  setExpand: Dispatch<SetStateAction<boolean>>;
}) {
  return (
    <div className="w-full flex flex-col p-2 pb-1 gap-2">
      <OperationHeader
        operation={operation}
        expand={expand}
        setExpand={setExpand}
      />
      <div className="w-full flex gap-4">
        <MaterialNameSelect keyPath={["part_name"]} />
        <Input
          label="Quantity 1 Cost"
          keyPath={["qty_1_cost"]}
          unit="currency"
          width={100}
        />
        <Input label="Add Blanks" keyPath={["additional_blanks"]} />
      </div>
      {expand && (
        <div className="w-full flex justify-between items-start">
          <VolumeDiscount />
          <Input
            label="Min. Blank"
            keyPath={["min_blank_cost"]}
            unit="currency"
          />
          <div className="self-end flex flex-col items-end gap-4">
            <div className="text-xs text-gray-400">Blanks</div>
            <div className="text-xs text-gray-400">Cost</div>
            <Input label="Markup" keyPath={["markup"]} suffix="%" width={60} />
          </div>
        </div>
      )}
    </div>
  );
}

function Right({ expand }: { expand: boolean }) {
  return (
    <>
      {expand && <BlanksCosts />}
      <CostColumns />
    </>
  );
}

function BlanksCosts() {
  const { quantities } = useOperationListContext();

  return (
    <div className="grow flex divide-x divide-slate-100">
      {quantities.map((q) => (
        <div
          key={q}
          className="px-1 pb-1 flex flex-col justify-end items-end gap-2"
          style={{
            maxWidth: quantityColumnWidth,
            minWidth: quantityColumnWidth,
          }}
        >
          <Input keyPath={["by_quantity", q, "blanks"]} alignRight />
          <UnitCostInput quantity={q} fieldName="total_cost" />
        </div>
      ))}
    </div>
  );
}
